module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1Q4OKg/tc-custom/9781423661481.jpg?1737126692189",
      "alt": "This image is the cover for the book Southern Lights"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Southern Lights\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This is a hassle-free, lighter take on Southern cooking that proves the notion less can so often be more. By reimagining beloved Southern classics and viewing them through a more health- and lifestyle-conscious lens, Lauren McDuffie’s Southern Lights: Easier, Lighter, and Better-for-You Recipes From the South explores ways to make Southern cooking more accessible without sacrificing flavor or quality. Setting traditionally heavy recipes to a decidedly more healthful tune and showing off some Southern fare that is already light to begin with (the heart of Southern cooking beats for fresh, seasonal produce), this cookbook will give you ways to enjoy your favorite Southern dishes more often. It is bursting with some seriously delicious Southern powerhouses—a true all-star lineup—for breakfasts, lunches, appetizers, snacks, dinners, holiday dishes, desserts, and more.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lauren McDuffie\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0